import { Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import Main from './pages/p-main';
import Pick from './pages/p-pick';
import SignIn from './pages/p-sign-in';
import Thanks from './pages/p-tks';
import Terms from './pages/p-tos';
import Recording from './pages/p-recording';
import Trigger from './pages/p-trigger-recorder';

import Resolver from './components/c-resolver';

import './theme/index.css';

export default function App() {
	return (
		<IonApp style={{ height: window.innerHeight }}>
			<IonReactRouter>
				<IonRouterOutlet>
					<Route exact path='/:iauid/:otp/:srv'>
						<SignIn />
					</Route>
					<Route exact path='/B'>
						<Terms />
					</Route>
					<Route exact path='/D'>
						<Pick />
					</Route>
					<Route exact path='/E'>
						<Trigger />
					</Route>
					<Route exact path='/H'>
						<Recording />
					</Route>
					<Route exact path='/G'>
						<Thanks />
					</Route>
					<Route exact path='/'>
						<Main />
					</Route>
				</IonRouterOutlet>
			</IonReactRouter>
		</IonApp>
	);
}
